//import 'ol/ol.css';
import * as toastr from "toastr";
import { ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { UserDefinedFields } from "../UserDefinedFields/UserDefinedFields";
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_PathStatements {

    // ----------------------------------------------------------- //
    // GLOBAL VARS


    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openStatementCreatePanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Path/PathStatementCreate', { routeCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Show the form
            Utilities.GetModal('#pathStatementCreateModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#pathStatementCreateModal"));

            // Bind buttons
            $('#pathStatementCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#pathStatementCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#pathStatementCreateModal .modal-content"));
                let formData = new FormData(<any>$('#pathStatementCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Route/CreateRouteStatement',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                                Utilities.GetModal('#pathStatementCreateModal', ModalAction.Hide);
                                callback(true);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#pathStatementCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#pathStatementCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#pathStatementCreateModal', ModalAction.Hide);
                callback(false);
            });

            $('#pathStatementCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#pathStatementCreateModal', ModalAction.Hide);
                callback(false);
            });
        });
    }

    public openStatementEditPanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;
    
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Path/PathStatementEdit', { statementId: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Show the form
            Utilities.GetModal('#pathStatementEditModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#pathStatementEditModal"));

            // Bind buttons
            $('#pathStatementEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#pathStatementEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#pathStatementEditModal .modal-content"));
                let formData = new FormData(<any>$('#pathStatementEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Route/UpdateRouteStatement',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated statement!')
                                Utilities.GetModal('#pathStatementEditModal', ModalAction.Hide);
                                UserDefinedFields.SaveUDFFieldsAtServer($('#pathStatementEditForm'), '/Route/UpdateRouteStatementUserFields');
                                callback(true);
                            }
                            else {
                                toastr.error('Failed to update statement!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#pathStatementEditModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#pathStatementEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#pathStatementEditModal', ModalAction.Hide);
                callback(false);
            });

            $('#pathStatementEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#pathStatementEditModal', ModalAction.Hide);
                callback(false);
            });

            $('#pathStatementEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(data.code as any, function (r) {
                    if (r == true) {
                        Utilities.GetModal('#pathStatementEditModal', ModalAction.Hide);
                        callback(true);
                    }
                });
            });
        });
    }

    // ---------------------------------------------------------------------------//
    // Get Data
    public GetPathStatements = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Route/GetRouteStatements";
        Utilities.BlockUI($('#pathEditStatementTable'));
        $.post(url, { routeCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#pathEditStatementTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#pathEditStatementTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        //$('#pathEditStatementTable [data-statementid]').on('click', function () {
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                            if (field =="statementID") {
                                var statementData: ICAMSKey = $element.find("[data-statementid]").data("statementid");
                                self.openStatementEditPanel(statementData, function (r) {
                                    events.bus.publish(events.eventOpenPathEditPanel(data));
                                });
                                Utilities.GetModal('#pathEditModal', ModalAction.Hide);                            }                            
                        });
                    }
                    else {
                        toastr.error('Failed to get legal data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (statementId: number, callback: Function): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Route/DeleteRouteStatement', { statementId: statementId },
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            callback(true);
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }
}




